import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPlaylistAddCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M11.666 8.333h-10V10h10V8.333zm0-3.333h-10v1.667h10V5zm-10 8.333h6.667v-1.666H1.666v1.666zm16.25-3.75l1.25 1.25-5.825 5.834-3.758-3.75 1.25-1.25 2.508 2.5 4.575-4.584z"
	})
});
export default SvgIconPlaylistAddCheck;
